import { cancelExternalSubscription } from "@/api/purchase";
import { AxiosError } from "axios";
import { useMutation } from "react-query";

export const useCancelExternalSubscriptions = () => {
  return useMutation<unknown, AxiosError, { old_platform: string }>(
    (payload) => {
      return cancelExternalSubscription(payload);
    },
  );
};
